export const getElementValueBarVariant = (
  fixturesStatus: {
    hasStarted: boolean;
    hasLive: boolean;
    allFinished: boolean;
  } | null,
): "default" | "live" | "finished" => {
  if (fixturesStatus?.hasLive) return "live";
  if (fixturesStatus?.allFinished) return "finished";
  return "default";
};
